import _ from 'lodash';

import CMLParser from 'bundles/cml/legacy/models/CMLParser';

import Element from './Element';
import InlineElement from './InlineElement';

class Text extends Element {
  constructor(doc: Document, node: HTMLElement) {
    super(doc, node, 'p', 'text', {});

    _.forEach(this.childNodes, (childNode) => {
      const inlineElement = new InlineElement(this.doc, childNode as HTMLElement);
      this.block.appendChild(inlineElement.block);
    });

    if (CMLParser.hasMath(this.block)) {
      this.setBlockAttribute('hasMath', true);
    }
  }
}

export default Text;
